const LOCAL_DOMAIN = import.meta.env.VITE_APP_N0DES_BASE_DOMAIN || "localhost"
export const N0DES_API_PREFIX =
  ~~window.location.hostname.indexOf("local") >= 0
    ? `http://${LOCAL_DOMAIN}:8000/api/`
    : `https://${window.location.hostname}/api/`
